import { render } from "./Inputer.vue?vue&type=template&id=bba40f12&scoped=true"
import script from "./Inputer.vue?vue&type=script&lang=js"
export * from "./Inputer.vue?vue&type=script&lang=js"

import "./Inputer.vue?vue&type=style&index=0&id=bba40f12&scoped=true&lang=css"
import "./Inputer.vue?vue&type=style&index=1&id=bba40f12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba40f12"],['__file',"src/components/Inputer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bba40f12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bba40f12', __exports__)) {
    api.reload('bba40f12', __exports__)
  }
  
  module.hot.accept("./Inputer.vue?vue&type=template&id=bba40f12&scoped=true", () => {
    api.rerender('bba40f12', render)
  })

}


export default __exports__